export default __webpack_public_path__ + "static/media/transfer-external.2c4ab510.svg";